import CsSidebar from './CsSidebar.vue'
CsSidebar.install = function (Vue) {
  Vue.component(CsSidebar.name, CsSidebar)
}
export default CsSidebar


// WEBPACK FOOTER //
// ./src/components/sidebar/index.js